import React, { useEffect, useState, useRef } from "react";

const Canvas = (props) => {
    const canvasRef = useRef(null)

    const drawPoint = (ctx, x,y, r=0.5) => {
        ctx.beginPath()
        ctx.arc(x, y, r, 0, 2*Math.PI)
        ctx.fill()
    }

    const delay = (ms) => new Promise(res => setTimeout(res, ms))
    
    const updateCanvas = (props) => {
        const canvas = canvasRef.current
        if(!canvas) { return  }
        // const dpr = window.devicePixelRatio || 2
        const dpr = 1
        const rect = canvas.getBoundingClientRect()
        // canvas.width = 200 //rect.width * dpr
        canvas.width = 1.1*Math.max(...props.points.filter(xy => typeof(xy) == "object").map(xy => xy[0]))
        canvas.height = 1.1*Math.max(...props.points.filter(xy => typeof(xy) == "object").map(xy => xy[1]))
        console.log("width=", canvas.width, " height=", canvas.height)
        console.log("dpr=", dpr)
        const ctx = canvas.getContext("2d")
        ctx.scale(dpr, dpr)
        ctx.fillStyle = "black"
        props.points.slice(0, props.id).forEach(xy => {
            if(typeof(xy) == "object" && xy.length == 2 && typeof(xy[0]=="number")) {
                drawPoint(ctx, xy[0], xy[1], 1)
            }
            else if( typeof(xy) == "string" && xy.match("clear")) {
                ctx.clearRect(0, 0, canvas.width, canvas.height)
            }
            else if(typeof(xy) == "string" && xy.match("color_(\\w+)")) {
                const color = xy.match("color_(\\w+)")[1]
                // console.log("COLOR", color)
                ctx.fillStyle = color
            }
        });
    }

    useEffect(() => updateCanvas(props),)

    return(
        <div>
            <canvas ref={canvasRef} style={{border:"1px solid black", 
                width:"50%", height:"50%"}}>
            </canvas>
        </div>
    )

}

export default Canvas